// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.td_underline[data-v-0740e512] {text-decoration: underline; color: inherit; cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
